import { html } from "htm/preact";
import { render } from "preact";
import Gallery from "../components/Gallery.js";

const galleries = document.querySelectorAll("[data-gallery]");
galleries.forEach((gallery) => {
  const mountDiv = gallery.querySelector("[data-gallery-mount]");
  if (mountDiv) {
    render(html`<${Gallery} container=${gallery} />`, mountDiv);
  }
});
